import '../splashscreen/splash.css';



export const SplashScreen = () => {
  return (
    <div className="splash"></div>
  )
}
